// Utils
import { propIn } from '../../../common/utils/immutableHelper';

export const debugToolProperties = (toolName) => propIn(['debug', 'tools', toolName]);
export const debugToolProperty = (toolName, property) => propIn(['debug', 'tools', toolName, property]);
export const debugToolLastUpdateTime = (toolName) => debugToolProperty(toolName, 'lastUpdateTimestamp');
